import React, { Component, Fragment } from "react";
import Style from "./index.module.less";
import {
  Input,
  Select,
  Row,
  Col,
  Button,
  Pagination,
  Tooltip,
  Tabs,
  Popover,
  Table,
  Popconfirm,
  message,
  TreeSelect,
  Checkbox,
  Alert,
  Spin,
  Modal
} from "antd";
import '../../match/list/list.less'
import '@/static/style/basetable.less'
import DateChoose from "@/compenents/newDateChoose";
import moment from "moment";
// import '@ant-design/pro-table/dist/table.css'
import ProTable from "@ant-design/pro-table";
import common from "@/public/common";
import {toggleFullScreen} from '../../match/common/utils'
import { exitFullScreen, fullScreen, getSid, getFormatDate, objToArr } from "@/public/utils";
import NewPagination from '@/compenents/newpagination/newpagination';

import {
  ajaxApi,
  fileDownloadApiHui,
  getMethod,
} from "@/server";
import AddModal from "./AddModal";
import "./index.less";
import '@/static/style/basetable.less'
import { fetchSigoCompany } from '../../match/common/api'
import { getCookieInfo } from './utils'
import _, { get, set } from 'lodash'
import { getFormatDateIsNull, filterSigoCompanyCol } from '../../match/common/utils'
import {transferx0ToX0} from '../../match/common/utils'

import {
  FullscreenOutlined,
} from "@ant-design/icons";
import { outputMoney } from "@/public/utils";
import commons from "../../../../public/common";
import { getCookieNew } from "../../../../public/utils";
const { Option } = Select;
var apiHost = common.SapUrl
// var apiHost = 'http://192.168.10.67:8120/' || common.SapUrl

class ManualUpload extends Component {
  child = null;
  components = {
    header: {
      //   cell: ResizeableTitle,
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      invoiceOptions: [],
      statusOptions: [],
      orderOptions: [],
      matchOptions: [],
      signOptions: [],
      idenStatusOptions: [],
      idenTypeOptions: [],
      purchaseOptions: [],
      invoiceProviderOptions: [],
      moneyValueOptions: [
        { key: "sum_total_amount", uname: "含税金额合计", value: "" },
        { key: "sum_tax_amount", uname: "税额合计", value: "" },
        { key: "sum_have_match_amount", uname: "已匹配金额合计", value: "" },
        { key: "sum_remain_amount", uname: "未匹配金额合计", value: "" },
      ],
      loading: false,
      isToggle: false,
      data: [],
      // columns: manualColumns,
      total: 0,
      searchParams: {
        page_no: 1,
        page_size: 10,
        query: {
          // is_show_status_count: true,
          invoice_id: "", //发票单号
          invoice_source: "02",
          invoice_code: "", //发票代码
          invoice_type_list: [], //增值税专用发票：01,增值税电子专用发票：08 电子发票（增值税专用发票）：31
          buyer_no: "", //采购主体编码/名称
          saler_no: "", //开票供应商编码/名称
          invoice_status_list: [], //发票状态
          matches_status_list: [], //匹配状态
          match_id: "", //匹配单号
          sign_status_list: [], //签收状态
          legalize_state_list: [], //认证状态
          date_type: "1", //时间类型1开票日期  2认证日期 3异常日期 4提交日期 5创建日期 6审核日期 
          start_date: moment().startOf('day').subtract(89, 'days').valueOf(), //开始时间
          end_date: moment().endOf('day').valueOf(), //结束时间
          exception_status_list: [], //异常发票处理状态
          status_list: [], //单据状态,
          status: "", //tab切换的值
          supplier_no:getCookieNew('supplier_code')||''
        },
      },
      dialogTitle: "",
      visible: false,
      type: "add",
      exportLoading: false,
      editData: {},
      activeKey: "",
      enums: {},
      expand: true,
      total_num:0,
    };
    this.search = _.throttle(this.search ,1000)
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKeyup);
    this.getOptions();
    this.getPurchaseOptions();
  }

  getPurchaseOptions = async () => {
    try {
      const {
        data = {}
      } = (await fetchSigoCompany()) || {}
      this.setState({ purchaseOptions: objToArr(get(data, 'data')) })
    } catch (err) {
      console.log(err)
    }
  };
  getOptions = () => {
    let { searchParams } = this.state
    set(searchParams, 'query.sid', getSid())
    getMethod(apiHost + "invoice/get-enums").then((res) => {
      var result = transferx0ToX0(res.data)
      console.log(result,'result')
      let keyArray = {
        匹配单状态枚举值: [],
        发票匹配状态枚举值: [],
        发票审批状态枚举值: [],
        发票来源枚举值: [],
        发票状态枚举值: [],
        发票签收状态枚举值: [],
        '发票类型枚举值(采购)': [],
        发票认证状态枚举值: [],
        异常发票状态枚举值: [],
        认证类型枚举值: [],
      };
      for (let item in keyArray) {
        for (let i in result[item]) {
          keyArray[item].push({
            key: i,
            value: result[item][i],
            num: 0,
            statusNum: "status" + i.slice(1) + "_num",
          });
        }
      }
      set(searchParams,'invoice_type_list',_.keys(get(result,'发票类型枚举值(人工)'))||[])
      this.setState({
        enums: result,
        statusOptions: keyArray["发票类型枚举值(采购)"],
        orderOptions: keyArray["发票审批状态枚举值"],
        matchOptions: keyArray["发票匹配状态枚举值"],
        activeKey: keyArray["发票审批状态枚举值"][0].key,
        searchParams
      });
      _.defer(this.search,1000)
    });
  };
  onKeyup = (e) => {
    if (e.charCode === 13 || e.keyCode === 13) {
      this.search();
    }
  };
  search = (resetPageNum = true, status) => {
    let {searchParams, activeKey } =
      this.state;
    if (resetPageNum) {
      searchParams.page_no = 1;
    }
    this.setState({
      loading: true,
    });
    searchParams.query.status = status || activeKey;
    this.searchAxios(searchParams)
  };

  searchAxios = (searchParams) => {
    let { moneyValueOptions, orderOptions } =
      this.state;
    ajaxApi({
      url: apiHost + "invoice/query-page-list",
      params: searchParams,
    })
      .then((res) => {
        var result = res.data.data
        moneyValueOptions.map((item) => {
          Object.keys(res.data.data).map((subItem) => {
            if (item.key == subItem) {
              item.value = res.data.data[subItem];
            }
          });
        });
        orderOptions.map((item) => {
          let {statusNum} = item
          set(item,'num',get(result,statusNum))
        });
        this.setState({
          loading: false,
          data: result.list,
          moneyValueOptions,
          total: res.data.total_count,
          total_num:get(result,'total_num'),
          orderOptions
        });
      })
      .catch((e) => {
        this.setState({
          loading: false,
        });
      });
  }

  queryResource = () => {
    if(get(this.state.orderOptions,'length')){
      this.searchAxios(this.state.searchParams)
    }
  }

  tableChange = (pagination, filters, sorter, extra) => {
    let {searchParams } = this.state
    var sort = { 
      'ascend':'asc',
      'descend':'desc',
    }
    set(searchParams,'query.sort_name',get(sorter,'field'))
    set(searchParams,'query.sort_sequence',get(sorter,'order')?sort[get(sorter,'order')]:null)
    this.setState({searchParams})
    _.defer(this.search,1000)
  }
  changePage = (page, size) => {
    let { searchParams } = this.state;
    searchParams.page_no = page;
    searchParams.page_size = size;
    this.setState(
      {
        searchParams,
      },
      () => {
        this.search(false);
      }
    );
  };
  export = () => {
    let { searchParams } = this.state;
    this.setState({
      exportLoading: true,
    });
    fileDownloadApiHui({
      url: apiHost + "invoice/query-page-list/export-manual",
      param: get(searchParams, 'query'),
      filename: "人工录入发票明细_" + moment().format("YYYYMMDDHHmmss") + ".xls",
    })
      .then((res) => {
        this.setState({
          exportLoading: false,
        });
      })
      .catch((e) => {
        this.setState({
          exportLoading: false,
        });
      });
  };
  changeTab = (key) => {
    let { searchParams } = this.state;
    searchParams.query["status"] = key;
    searchParams.query["status_list"] = key?[key]:[];
    this.setState(
      {
        searchParams,
        activeKey: key,
      },
      () => {
        this.search();
      }
    );
  };
  inputChange = (e) => {
    let _seachParamChange = this.state.searchParams;
    _seachParamChange.query[e.target.name] = e.target.value;
    this.setState({
      searchParams: _seachParamChange,
    });
  };
  changeSelect = (e, type) => {
    let { searchParams } = this.state;
    searchParams.query[type] = e;
    this.setState({
      searchParams,
    });
  };
  changeTime = (time) => {
    let { searchParams } = this.state
    var query = get(searchParams, 'query')
    set(query, 'start_date', time[0] ? time[0].valueOf() : null)
    set(query, 'end_date', time[1] ? time[1].valueOf()  : null)
    this.setState({
      searchParams: {
        ...searchParams,
        query
      },
    });
    // _.defer(this.search, 1000)
  };
  onRef = (ref) => {
    this.child = ref;
  };
  add = () => {
    this.setState({
      visible: true,
      type: "add",
      dialogTitle: "新增发票",
    });
  };
  multiAdd = () => {
    this.setState({
      visible: true,
      type: "multiAdd",
      dialogTitle: "批量新建",
    });
  };
  rowCancel(e, row) {
    var { RealName, UserName, UserID } = getCookieInfo()
    ajaxApi({
      url: apiHost + "invoice/update-status",
      params: {
        ...row,
        status: '05',
        auditer: RealName, //创建人姓名
        auditer_py: UserName, //创建人拼音 
        auditer_id: UserID,
        sid: getSid(),
        adder_id: UserID,
      },
    }).then((res) => {
      if (res.data.code === 200) {
        message.success('作废成功')
        this.search(true, '05')
      } else {
        message.error('失败')
      }
    });
  }
  edit(text, row) {
    ajaxApi({
      url: apiHost + "invoice/query-invoice",
      params: { invoice_id: row.invoice_id },
    }).then((res) => {
      this.setState({
        visible: true,
        dialogTitle: "编辑发票 ",
        editData: res.data.data,
        type: "edit",
      });
    });
  }

  showErrModal=(data)=>{
    this.setState({
      allerror_maplist:data,
      visible:false,
      errlogvisiable:true
    })
  }
  renderTableHeader = () => {
    // message.error('renderTableHeader')
    const { orderOptions, moneyValueOptions } = this.state;
    return (
      <div className={'pro_table_tab'}>
        <Tabs
          onChange={this.changeTab}
          defaultActiveKey="04"
          type="card"
        >
          <Tabs.TabPane
            tab={`全部(${this.state.total_num})`}
            key={''}
          ></Tabs.TabPane>
          {orderOptions.map((item) => {
            return (
              <Tabs.TabPane
                tab={`${get(item,'value')}(${get(item,'num')})`}
                key={get(item,'key')}
              ></Tabs.TabPane>
            );
          })}
        </Tabs>
      </div>
    );
  };

  matchIdListClick = (code,id)=>{
    if(code){
      if(code.includes("PTPD")){
      }else{
        window.open(`${commons.scsWebUrl}main/bill/match/detail?match_id=${code}`)
      }
    }
  }
  handleResize =
    (index) =>
      (e, { size }) => {
        this.setState(({ columns }) => {
          const nextColumns = [...columns];
          nextColumns[index] = {
            ...nextColumns[index],
            width: size.width,
          };
          return { columns: nextColumns };
        });
      };
  render() {
    let {
      statusOptions,
      matchOptions,
      orderOptions,
      loading,
      data,
      columns,
      searchParams,
      total,
      dialogTitle,
      visible,
      type,
      purchaseOptions,
      invoiceProviderOptions,
      exportLoading,
      editData,
      enums,
      moneyValueOptions,
      expand
    } = this.state;
    const StatusColorMap = { "00": "#bfbfbf", "02": "#00a854", "05": "#f04134 " }
    const manualColumns = [
      {
        title: "发票单号",
        dataIndex: "invoice_id",
        align: "center",
        fixed: "left",
        width: 140,
        render: (text, row) => {
          return (
            <a
              onClick={() => {
                this.edit(text, row);
              }}
            >
              {text}
            </a>
          )
        }
      },
      {
        title: "开票日期",
        dataIndex: "invoice_date",
        align: "center",
        width: 90,
        render: (text) => getFormatDateIsNull(text, 'YYYY-MM-DD')
      },
      {
        title: "发票号码",
        dataIndex: "invoice_no",
        align: "center",
        width: 130,
      },
      {
        title: "发票类型",
        dataIndex: "invoice_type",
        align: "center",
        width: 140,
        render: (text, row) => {
          return (
            <span>
              {text?get(this.state.enums, '发票类型枚举值(人工)')[text] : "--"}
            </span>
          );
        },
      },
      {
        title: "结算主体",
        dataIndex: "buyer_name",
        align: "center",
        width: 200,
        ellipsis: true,
      },
      {
        title: "发票状态",
        dataIndex: "status",
        align: "center",
        width: 80,
        ellipsis: true,
        render: (text, record) => {
          return (
            <span>
              <span style={{
                display: 'inline-block', width: 6, height: 6, marginRight: 4, borderRadius: '50%', backgroundColor: StatusColorMap[get(record, 'status')]
              }} />{get(record, 'status_name') || '-'}</span>
          )
        }
      },
      {
        title: "含税金额",
        dataIndex: "total_amount",
        align: "center",
        width: 160,
        render:(text,record)=><div style={{ textAlign: "right" }}>{outputMoney(get(record,'total_amount'))}</div>
      },
      {
        title: "税额",
        dataIndex: "tax_amount",
        align: "center",
        width: 120,
        render:(text,record)=><div style={{ textAlign: "right" }}>{outputMoney(get(record,'tax_amount'))}</div>
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        align: "center",
        width: 150,
        hideInSearch: true,
        sorter: true,
        render: (text) => getFormatDateIsNull(text, 'YYYY-MM-DD hh:mm:ss')
      },
      {
        title: "提交时间",
        dataIndex: "apply_time",
        align: "center",
        width: 150,
        hideInSearch: true,
        sorter: true,
        render: (text, record) => get(record, 'apply_time') ? getFormatDate(get(record, 'apply_time')) : "-"

      },
      {
        title: "备注",
        dataIndex: "remark",
        align: "center",
        width: 80,
      },
      {
        title: "已匹配金额",
        dataIndex: "have_match_amount",
        align: "center",
        width: 140,
        render:(text,record)=><div style={{ textAlign: "right" }}>{outputMoney(get(record,'have_match_amount'))}</div>
      },
      {
        title: "未匹配金额",
        dataIndex: "remain_amount",
        align: "center",
        width: 120,
        render:(text,record)=><div style={{ textAlign: "right" }}>{outputMoney(get(record,'remain_amount'))}</div>
      },
      {
        title: "匹配状态",
        dataIndex: "matches_status",
        align: "center",
        width: 90,
        render: (text, row) => {
          return (
            <span>
              {
                this.state.matchOptions.filter((item) => item.key === text)[0]
                  .value
              }
            </span>
          );
        },
      },
      {
        title: "票单关联号",
        dataIndex: "match_id_list",
        align: "center",
        width: 120,
        render: (text, record) => {
          var { match_id_list } = record
          if (!_.get(match_id_list, "length")) {
            return '-'
          }
          if (_.get(match_id_list, "length") > 1) {
            return (
              <Popover
                placement="right"
                content={
                  <div>
                    {
                      (match_id_list.filter((item, index) => index != 0) || []).map((_item, _index) => {
                        return (
                          <div key={_index} onClick={() => { this.matchIdListClick(_item) }}>
                          {
                            _item.includes("PTPD")?<span>{_item}</span>: <a >{_item}</a>
                          }
                        </div>
                        )
                      })
                    }
                  </div>
                }
              >
                 {
                  (get(match_id_list,"[0]")||"").includes("PTPD")?<span>{get(match_id_list,"[0]")}</span>:<a onClick={() => { this.matchIdListClick(get(match_id_list,"[0]")) }}>{get(match_id_list,"[0]")}</a>
                }
              </Popover>
            )
          } else {
            return  (get(match_id_list,"[0]")||"").includes("PTPD")?<span>{get(match_id_list,"[0]")}</span>:<a onClick={() => { this.matchIdListClick(get(match_id_list,"[0]"))}}>{get(match_id_list,"[0]") || "-"}</a>
          }
        }
      },
      {
        title: "操作",
        fixed: "right",
        align: "center",
        width: 80,
        ellipsis: true,
        render: (text, row) => {
          return (
            <span>
              {
                get(row, 'status') == '00' &&
                <a
                  onClick={() => {
                    this.edit(text, row);
                  }}
                >
                  编辑
                </a>
              }
              {
                ((get(row, 'status') == '02' && get(row, 'matches_status') == '00') || get(row, 'status') == '00') &&
                <Popconfirm
                  placement="top"
                  title={"确认将此单作废?"}
                  onConfirm={() => this.rowCancel(text, row)}
                  okText="确认"
                  cancelText="取消"
                >
                  <a
                    className="ml6"
                  >
                    作废
                  </a>
                </Popconfirm>
              }

            </span>
          );
        },
      },
    ];
    const columns1 = filterSigoCompanyCol(purchaseOptions, manualColumns,searchParams)
    return (
      <div className="matchlist">
        <div className={' roundBorder mb24'}>
          <div className={Style.row}>
            <span className={Style.key}>发票单号：</span>
            <Input
              style={{ width: "150px", height: 30 }}
              placeholder="发票单号"
              allowClear
              name="invoice_id"
              onChange={this.inputChange}
            />
            <span className={Style.key}>发票号码：</span>
            <Input
              style={{ width: "150px", height: 30 }}
              placeholder="发票号码"
              allowClear

              name="invoice_no"
              onChange={this.inputChange}
            />
            <span className={Style.key}>票单关联号：</span>
            <Input
              style={{ width: "170px" }}
              placeholder="请输入"
              allowClear
              name="match_id"
              onChange={this.inputChange}
            />
            <Select
              style={{ width: "100px", marginRight: 8,marginLeft:12 }}
              defaultValue="1"
              allowClear
              onChange={(e) => {
                this.changeSelect(e, "date_type");
              }}
            >
              <Option value="1">开票日期</Option>
              <Option value="4">提交时间</Option>
              <Option value="5">创建时间</Option>
            </Select>
            <DateChoose
              defaultValue={'ninetyDays'}
              ifConvenient={true}
              isStatus={true}
              isClick={false}
              ifshowClear={true}
              time={true}
              timerChange={this.changeTime}
            />

          </div>

          <div>
            <span className={Style.key}>匹配状态：</span>
            <Select
              placeholder="匹配状态"
              allowClear
              mode="multiple"
              style={{ width: "150px" }}
              onChange={(e) => {
                this.changeSelect(e, "matches_status_list");
              }}
            >
              {matchOptions.length > 0
                ? matchOptions.map((item) => {
                  return (
                    <Option value={item.key} key={item.key}>
                      {item.value}
                    </Option>
                  );
                })
                : null}
            </Select>
            <span className={Style.key}>发票类型：</span>
            <Select
              placeholder="发票类型"
              allowClear
              mode="multiple"
              style={{ width: "150px" }}
              options={objToArr(get(this.state.enums, '发票类型枚举值(人工)'))}
              onChange={(e) => {
                this.changeSelect(e, "invoice_type_list");
              }}
            />
            {
              get(purchaseOptions, 'length') > 1 &&
              <span>
                <span className={Style.key} style={{ width: '100px' }}>结算主体：</span>
                <Select
                  placeholder="请输入"
                  allowClear
                  style={{ width: "196px" }}
                  showArrow
                  showSearch
                  options={purchaseOptions}
                  optionFilterProp={'label'}
                  onChange={(e) => {
                    this.changeSelect(e, "buyer_no");
                  }}
                >
                </Select>
              </span>
            }

            <Button
              type="primary"
              className="mr8 ml20"
              shape="round"
              onClick={this.search}
              onKeyDown={this.onKeyup}
            >
              查询
            </Button>
            <Button
              shape="round"
              className="mr8"
              onClick={() => {
                window.location.reload();
              }}
            >
              重置
            </Button>
            <Button
              shape="round"
              className="mr8"
              loading={exportLoading}
              onClick={this.export}
            >
              导出
            </Button>
            <Button
              shape="round"
              type="primary"
              className="mr8"
              onClick={this.add}
            >
              新建发票
            </Button>
            <Button
              shape="round"
              type="primary"
              onClick={this.multiAdd}
            >
              批量创建发票
            </Button>
          </div>
        </div>
        <Spin spinning={loading}>
        <div className="componentsTable roundBorder boldHeader">
          <Alert message={
            <Fragment>
              {moneyValueOptions.map((item) => {
                return (
                  <span key={item.key} >
                    <span className='font14'>{item.uname}:</span>
                    <span style={{ color: "red", marginLeft: 6 }} className='font14 mr20'>
                      {outputMoney(item.value)}
                    </span>
                  </span>
                );
              })}
            </Fragment>
          }></Alert>
          <ProTable
            rowKey={"invoice_id"}
            components={this.components}
            scroll={{ x: 2140 }}
            loading={loading}
            search={false}
            sticky={true}
            page
            toolbar={{
              title: this.renderTableHeader(),
              actions: [
                <Tooltip placement="top" title="全屏">
                  <FullscreenOutlined
                    style={{
                      width: "1em",
                      height: "1em",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                    onClick={toggleFullScreen}
                  />
                </Tooltip>,
              ],
            }}
            dataSource={data}
            columns={columns1}
            request={this.queryResource}
            onChange={this.tableChange}
            tableAlertRender={false}
            columnEmptyText="--"
            options={true}
            pagination={false}
          ></ProTable>
          <div className={Style.turnRight}>
            <NewPagination total={total || 0} current={_.get(searchParams, "page_no")} pagesize={_.get(searchParams, "page_size")} pageChage={this.changePage} sizeChange={this.changePage} />
          </div>
        </div>
        </Spin>
        {/* 新建发票 */}
        {visible && (
          <AddModal
            search={this.search}
            dialogTitle={dialogTitle}
            visible={visible}
            type={type}
            enums={enums}
            editData={editData}
            statusOptions={statusOptions}
            invoiceProviderOptions={invoiceProviderOptions}
            purchaseOptions={purchaseOptions}
            rowCancel={this.rowCancel}
            clickCancel={(needReloadData) => {
              this.setState({
                visible: false,
                editData:{},
              });
              if(needReloadData){this.search()}
            }}
            clickOk={() => {
              this.setState({
                visible: false,
                editData:{},
              });
            }}
            showErrModal={this.showErrModal}
          />
        )}
        <Modal title="批量上传结果" width={700} visible={this.state.errlogvisiable} 
        onOk={()=>{
          this.setState({
             errlogvisiable:!this.state.errlogvisiable
          })
      }}
        okText="我知道了" 
        onCancel={()=>{
             this.setState({
                errlogvisiable:!this.state.errlogvisiable
             })
         }}>
         <div style={{maxHeight:'300px',overflowY:'auto'}}>
           {this.state.allerror_maplist ?
            this.state.allerror_maplist.map(a=> <p>{a}</p>)
           :null}
           </div>
        </Modal>
      </div>
    );
  }
}

export default ManualUpload


// WEBPACK FOOTER //
// ./src/pages/billVerification/createBills/artificialCreate/ManualUpload.js